import {
  Avatar,
  Box,
  Chip,
  Grid2,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import React, { Fragment } from "react";
import CopyIco from "../../../../assets/icons/CopyIco";
import DotsVerticalIco from "../../../../assets/icons/DotsVerticalIco";
import InfoIco from "../../../../assets/icons/InfoIco";
import CommonButton from "../../../../component/Button";
import DropDownSelect from "../../../../component/Select";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import {
  CommonGrid2,
  CustomTooltip,
  DotColor,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";
import { CustomizeMenu, CustomizeSpan } from "../../style";
import ScheduleCallIco from "../../../../assets/icons/ScheduleCallIco";

export default function ProfileInformation({
  matchedData,
  filteredResumeTab,
  loading,
  isRequestLoading,
  handleRequestInfo,
  candidateProfileValue,
  handleChangeStatus,
  handleCopyClick,
  handleCopyMouseLeave,
  copied,
  statusOptions,
  CustomMenuItem,
  menuItems,
  dotAnchorEl,
  anchorElCompare,
  handleCloseCompare,
  handleCompareNavigate,
  handleClickDot,
  openCompare,
  openDot,
  jobStatus,
  handleCloseDot,
  calendlyEvent,
  handleScheduleInterview,
  checkWidth,
}) {
  return (
    <Grid2 size={12}>
      <CommonGrid2
        display={"flex"}
        justifyContent={"space-between"}
        gap={"10px"}
        alignItems={"center"}
        flexWrap={"wrap"}
        container
        spacing={2}
      >
        <CommonGrid2 item size={{ xs: 12, sm: checkWidth < 650 ? 12 : 6 }}>
          <Stack direction="row" alignItems="center" gap={1.5}>
            <Avatar
              alt={matchedData?.candidate_name || "Avatar"}
              src={matchedData?.avatar_url}
              sx={{
                width: 65,
                height: 65,
                backgroundColor: "#F2F4F7",
                color: "#667085",
                border: "1px solid #D0D5DD",
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "1.6rem",
              }}
            >
              {loading ? (
                <HandleSkeletion height={30} width={25} />
              ) : (
                !matchedData?.avatar_url &&
                matchedData?.candidate_name?.[0]?.toUpperCase()
              )}
            </Avatar>

            <CommonGrid2 display={"flex"} flexDirection={"column"}>
              <Typography fontSize={"24px"} fontWeight={600}>
                {loading ? (
                  <HandleSkeletion height={35} width={80} />
                ) : (
                  matchedData?.candidate_name
                )}

                {!loading && (
                  <DropDownSelect
                    marginTop="0px"
                    removeAnimation={true}
                    renderValue={false}
                    data={statusOptions}
                    valueChange={true}
                    fullWidth={false}
                    CustomMenuItem={CustomMenuItem}
                    disabled={
                      matchedData?.status == "Rejected" ||
                      jobStatus === "Closed" ||
                      jobStatus === "Cancelled" ||
                      jobStatus === "Filled"
                    }
                    handleRenderValue={(selected) => {
                      const selectedOption = statusOptions.find(
                        (option) => option.id === selected
                      );

                      return (
                        <Box display={"flex"} alignItems={"center"}>
                          <DotColor
                            color={selectedOption.color}
                            marginRight="8px"
                          />
                          <Typography>{selectedOption.name}</Typography>
                        </Box>
                      );
                    }}
                    customStyle={{
                      "& .MuiSelect-select": {
                        padding: "4px 32px 4px 10px !important",
                        borderRadius: "6px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#D0D5DD",
                        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                      },
                      "& .MuiSelect-icon": {
                        right: "0rem",
                      },
                      margin: "0px 10px",
                    }}
                    value={matchedData?.status || candidateProfileValue}
                    handleChange={(e) => handleChangeStatus(e)}
                  />
                )}
              </Typography>
              {loading ? (
                <HandleSkeletion height={25} width={200} transform="scale(1)" />
              ) : (
                <>
                  {matchedData?.email ? (
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                      textTransform={"elli"}
                    >
                      <Link
                        href={`mailto:${matchedData?.email}`}
                        underline="none"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          color: "#7F56D9",
                          fontSize: "16px",
                          fontFamily: "Inter",
                          maxWidth: "fit-content",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          display: "block",
                        }}
                      >
                        {matchedData?.email}
                      </Link>
                      <CustomTooltip
                        arrow
                        placement="top"
                        title={copied ? "Copied!" : "Copy to Clipboard"}
                        fontSize="12px"
                        padding="5px 10px"
                        margin="0px 0px 10px !important"
                      >
                        <IconButton
                          onClick={() => handleCopyClick(matchedData?.email)}
                          style={{ padding: "0px" }}
                          onMouseLeave={handleCopyMouseLeave}
                        >
                          <CopyIco />
                        </IconButton>
                      </CustomTooltip>
                    </Stack>
                  ) : null}
                </>
              )}
              {loading ? (
                <HandleSkeletion height={25} width={100} />
              ) : (
                <Typography
                  variant="p"
                  display={"flex"}
                  alignItems={"center"}
                  gap={"5px"}
                >
                  <b>Candidate ID :</b>
                  {matchedData?.resume_info?.candidate_order_no ? (
                    matchedData?.resume_info?.candidate_order_no
                  ) : (
                    <CustomTooltip
                      backgroundColor="#000"
                      title={
                        <CustomDiv>
                          <Typography variant="subtitle2" fontWeight={700}>
                            Reason for No Candidate ID
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            color="#D0D5DD"
                          >
                            The candidate ID will be generated once you save
                            their record to the Candidate Hub.
                          </Typography>
                        </CustomDiv>
                      }
                    >
                      <CustomizeSpan cursor="pointer" display="flex">
                        <InfoIco />
                      </CustomizeSpan>
                    </CustomTooltip>
                  )}
                </Typography>
              )}
            </CommonGrid2>
          </Stack>
          {loading ? (
            <HandleSkeletion height={30} width={100} />
          ) : (
            <Fragment>
              {matchedData?.job_enrollment_status && (
                <Typography fontWeight={500} marginTop={"10px"}>
                  <b>Job Enrollment Status : </b>
                  <CustomizeSpan>
                    {matchedData?.job_enrollment_status}
                  </CustomizeSpan>
                </Typography>
              )}
            </Fragment>
          )}
        </CommonGrid2>
        {loading ? (
          <HandleSkeletion height={100} width={200} />
        ) : (
          <CommonGrid2
            item
            gap={"1rem"}
            flexWrap="wrap"
            display={"flex"}
            alignItems={"center"}
            justifyContent={"end"}
            size={{ xs: 12, sm: checkWidth < 650 ? 12 : 6 }}
          >
            <CommonButton
              startIcon={<ScheduleCallIco />}
              gap={"0px"}
              value={"Schedule Call"}
              padding={"10px 14px"}
              variant="outlined"
              color={"#344054"}
              border={"#D0D5DD"}
              fontWeight={"600"}
              customStyle={{
                "&:hover svg path": {
                  fill: "#fff",
                },
              }}
              disabled={
                calendlyEvent.length === 0 ||
                matchedData?.status === "Rejected" ||
                jobStatus === "Closed" ||
                jobStatus === "Cancelled" ||
                jobStatus === "Filled"
              }
              onClick={handleScheduleInterview}
            />

            <CommonButton
              value={"Request Info"}
              padding={"10px 14px"}
              variant="outlined"
              color={"#344054"}
              border={"#D0D5DD"}
              fontWeight={"600"}
              onClick={handleRequestInfo}
              loading={isRequestLoading}
              disabled={
                loading ||
                isRequestLoading ||
                matchedData?.rice_created === false ||
                matchedData?.submission_document_updated ||
                matchedData?.status == "Rejected" ||
                jobStatus === "Closed" ||
                jobStatus === "Cancelled" ||
                jobStatus === "Filled"
              }
            />
            <div>
              <CommonButton
                value={<DotsVerticalIco />}
                padding={"10px 14px"}
                variant="outlined"
                color={"#344054"}
                border={"#D0D5DD"}
                fontWeight={"600"}
                svg={true}
                aria-controls={openDot ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openDot ? "true" : undefined}
                onClick={handleClickDot}
                minWidth={"20px !important"}
                disabled={isRequestLoading}
              />

              <CustomizeMenu
                id="basic-menu"
                anchorEl={dotAnchorEl}
                open={openDot}
                onClose={handleCloseDot}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {menuItems.map((item, index) => (
                  <MenuItem
                    key={index}
                    onClick={item.disabled ? () => {} : item.onClick}
                    aria-controls={item.ariaControls}
                    aria-haspopup={item.ariaHasPopup}
                    aria-expanded={item.ariaExpanded}
                    style={{ opacity: item.disabled ? 0.5 : 1 }}
                    disabled={item?.disabled}
                  >
                    <StyledFlexRowView>
                      {item.icon}
                      <Typography>{item.label}</Typography>
                    </StyledFlexRowView>
                  </MenuItem>
                ))}
              </CustomizeMenu>

              <Menu
                id="basic-menu"
                anchorEl={anchorElCompare}
                open={openCompare}
                onClose={handleCloseCompare}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {filteredResumeTab?.map((item, imdex) => (
                  <MenuItem
                    sx={{ marginTop: "10px" }}
                    onClick={() => handleCompareNavigate(item)}
                  >
                    <>
                      <ListItemIcon>
                        <Avatar
                          alt={item?.name}
                          sx={{
                            width: 28,
                            height: 28,
                            fontWeight: 600,
                            fontSize: "1rem",
                          }}
                        >
                          {item?.name && item?.name?.[0]?.toUpperCase()}
                        </Avatar>
                      </ListItemIcon>
                      <ListItemText>
                        <CommonGrid2
                          display={"flex"}
                          flexDirection={"column"}
                          gap={"0px"}
                        >
                          <Typography>{item?.name}</Typography>
                          {item.record_type && (
                            <CustomizeSpan
                              width="max-content"
                              padding="0px"
                              color={
                                item.record_type === "GOLDEN RECORD"
                                  ? "#049F9A"
                                  : "#6941C6"
                              }
                              fontSize="12px"
                              fontWeight={700}
                              borderRadius="50px"
                            >
                              {item.record_type
                                ?.toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")}
                            </CustomizeSpan>
                          )}
                        </CommonGrid2>
                      </ListItemText>
                      <Chip
                        label={`${item?.score}%`}
                        variant="outlined"
                        size="small"
                        sx={{
                          paddingX: "5px",
                          paddingY: "1px",
                          marginLeft: "30px",
                        }}
                      />
                    </>
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </CommonGrid2>
        )}
      </CommonGrid2>
    </Grid2>
  );
}
